import React, { useState } from 'react';

import HomesCard from '../Card/HomesCard';
import HomesButton from '../Button/HomesButton';
import FileInput from '../../../../Components/FileInput/FileInput';
import SmallCard from '../../../../Components/SmallCard/SmallCard';
import Button from '../../../../Components/Button/Button';
import HomesModal from '../Modal/HomesModal';
import { mimeTypes } from '../../../../constants/constants';
import Input from '../../../../Components/Input/Input';

import pdf from '../../../../icons/PdfIcon.svg';
import styles from './homes.board.module.css';

const HomesBoard = ({building, subject}) => {
  const [selectedApartment, setSelectedApartment] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [complex, setComplex] = useState({});

  const success = (building.floor * 0.17).toFixed(0)
  const reg = (building.floor * 0.78).toFixed(0)
  const error = (building.floor * 0.05).toFixed(0)

  return (
    <div>
      <div className={styles.wrapper}>
        <HomesCard title='Права зарегистрированы' menu total={building.floor} amount={success} type='success'/>
        <HomesCard title='Поданы на регистрацию' menu total={building.floor} amount={reg}/>
        <HomesCard title='Ошибки' menu total={building.floor} amount={error} type='error'/>
      </div>
      <h4>Жилые помещения (Квартиры)</h4>
      <div className={styles.container}>
        <div className={styles.floors}>
          {building?.entrance && Array.from({ length: building?.entrance }).map((_, index) => (
            <HomesButton type='default' text={`Этаж ${index + 1}`} />
          ))}
        </div>
        <div className={styles.wrapper_apartments}>
          <div className={styles.apartments}>
            {building?.apartments && Array.from({ length: building?.apartments }).map((_, apartment) => (
              <div className={styles.apartment}>
                {building?.entrance && Array.from({ length: building?.entrance }).map((_, entrance) => (
                  <div className={styles.block} style={{ '--columns': `${ building?.doors }` }}>
                    {building?.doors && Array.from({ length: building?.doors }).map((_, door) => (
                      <HomesButton
                        onClick={() => {
                          setSelectedApartment(`Жилое помещение (Квартира) Подьезд ${apartment + 1} / Квартира ${apartment * building?.entrance * building.doors + entrance * building.doors + door + 1}`)
                          setIsOpen(true)
                        }}
                        key={door}
                        text={apartment * building?.entrance * building.doors + entrance * building.doors + door + 1}
                      />
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      {building?.parking &&
        <div>
          <h4>Машиноместа</h4>
          <div className={styles.container}>
            <div className={styles.floors}>
              <HomesButton type='default' text="Место №" />
            </div>
            <div className={styles.apartments}>
              {building?.parking && Array.from({ length: building?.parking }).map((_, index) => (
                <HomesButton
                  text={index + 1}
                  onClick={() => {
                    setSelectedApartment(`Машиноместо №${index + 1}`)
                    setIsOpen(true)
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      }
      {building?.pantry &&
        <div>
          <h4>Не жилые помещения (Кладовые)</h4>
          <div className={styles.container}>
            <div className={styles.floors}>
              <HomesButton type='default' text="Номер" />
            </div>
            <div className={styles.apartments}>
              {building?.pantry && Array.from({ length: building?.pantry }).map((_, index) => (
                <HomesButton
                  text={index + 1}
                  onClick={() => {
                    setSelectedApartment(`Не жилые помещения (Кладовые) №${index + 1}`)
                    setIsOpen(true)
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      }
      {building?.commerce &&
        <div>
          <h4>Не жилые помещения (Коммерция)</h4>
          <div className={styles.container}>
            <div className={styles.floors}>
              <HomesButton type='default' text="Номер" />
            </div>
            <div className={styles.apartments}>
              {building?.commerce && Array.from({ length: building?.commerce }).map((_, index) => (
                <HomesButton
                  text={index + 1}
                  onClick={() => {
                    setSelectedApartment(`Не жилые помещения (Коммерция) №${index + 1}`)
                    setIsOpen(true)
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      }
      {building?.utility &&
        <div>
          <h4>Не жилые помещения (Технические помещения)</h4>
          <div className={styles.container}>
            <div className={styles.floors}>
              <HomesButton type='default' text="Номер" />
            </div>
            <div className={styles.apartments}>
              {building?.utility && Array.from({ length: building?.utility }).map((_, index) => (
                <HomesButton
                  text={index + 1}
                  onClick={() => {
                    setSelectedApartment(`Не жилые помещения (Технические помещения) №${index + 1}`)
                    setIsOpen(true)
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      }
      <div>
        <div className={styles.wrapper}>
          <Input label='Номер разрешения на ввод в эксплуатацию'/>
          <Input label='Дата разрешения на ввод в эксплуатацию'/>
        </div>
        <label className={styles.label}>Загрузить разрешение на ввод в эксплуатацию</label>
        {complex?.document
          ?
          <div className={styles.document}>
            <SmallCard
              avatar={pdf}
              title={complex?.document.name}
            />
            <Button
              type='info'
              text='Направить участникам долевого строительства уведомление об окончании строительства на электронную почту (На основании постановления Правительства РФ от 29 декабря 2023 г. N 2380)'
            />
          </div>
          :
          <div>
            <FileInput
              accept={[mimeTypes.Xls, mimeTypes.Xlsx]}
              onChange={(value) => {
                setComplex({
                  ...complex,
                  document: value
                })
              }}
            />
          </div>
        }
        <div className={styles.download}>
          <i>Скачать <a href="#">шаблон</a> для заполнения данных по обьектам недвижимости для создания помещений</i>
        </div>
        <label className={styles.label}>Загрузите заполненный шаблон для загрузки помещений</label>
        {complex?.premises
          ?
          <div className={styles.document}>
            <SmallCard
              avatar={pdf}
              title={complex?.premises.name}
            />
          </div>
          :
          <FileInput
            accept={[mimeTypes.Xls, mimeTypes.Xlsx]}
            onChange={(value) => {
              setComplex({
                ...complex,
                premises: value
              })
            }}
          />
        }
      </div>
      <HomesModal
        selectedApartment={selectedApartment}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        subject={subject}
      />
    </div>
  );
};

export default HomesBoard;
